// extracted by mini-css-extract-plugin
export var buttons = "fileInput-module--buttons--RhmcS";
export var button = "fileInput-module--button--SORCB";
export var icon = "fileInput-module--icon--AUW0Z";
export var imagePreview = "fileInput-module--imagePreview--GTfKE";
export var imagePreviewTitle = "fileInput-module--imagePreviewTitle--ISFAh";
export var close = "fileInput-module--close--hPKoJ";
export var filename = "fileInput-module--filename--UfiWQ";
export var imagePreviewImage = "fileInput-module--imagePreviewImage--zxov7";
export var camera = "fileInput-module--camera--MO+is";